export default "__VITE_ASSET__414b75c4__"